<template>
  <div>
    <ins
      :class="['adsbygoogle', 'vue-adsense', 'mb-3']"
      :style="adStyle"
      :data-ad-client="adClient"
      :data-ad-slot="adSlot"
      :data-ad-format="adFormat" />
  </div>
</template>

<script>
  export default {
    name: 'VueAdsense',
    data () {
      return {
        adClient: this.$store.state.googleAdSenseClientId
      }
    },
    props: {
      adSlot: {
        type: String,
        required: true
      },
      adFormat: {
        type: String,
        required: false,
        default: 'auto'
      },
      adStyle: {
        type: String,
        required: false,
        default: 'display: block'
      }
    },
    mounted () {
      if (!document.getElementById('XuQnsBExZmfq')) {
        this.$store.commit('setAdBlockPlusEnabled')
      }
      (window.adsbygoogle = window.adsbygoogle || []).push({})
    }
  }
</script>


// WEBPACK FOOTER //
// src/vendor/vue-adsense/vue-adsense.vue